export default "__VITE_ASSET__e47b2e27__"